import page1 from "./01_PreliminaryQuestions";
import page2 from "./02_A_NatureH2B";
import page3 from "./03_B_TemporaryNeedInformation";
import page4 from "./04_C_EmployerInformation";
import page5 from "./05_D_PointOfContactInformation";
import page6 from "./06_E_AttorneyAgent";
import page7 from "./07_Fa_OpportunityMinimum";
import page8 from "./08_Fbc_PlaceEmployment";
import page9 from "./09_Fd_OtherMaterialTerms";
import page10 from "./10_Fe_RecruitmentInfo";
import page11 from "./11_GH_OtherSupportingDocumentation";
import page12 from "./12_I_Preparer";
import page13 from "./13_AppxA";
import page14 from "./14_AppxC";
import page15 from "./15_AppxD";
import page16 from "./16_ApplicationDocuments";

const form_meta = {
  code: "Form ETA-9142B",
  name: "H-2B Application for Temporary Employment Certification",
};

const form_nav = [
  {
    name: "Preliminary Questions",
    symbol: "list",
  },
  {
    name: "Nature of H-2B Application",
    prefix: "A",
  },
  {
    name: "Temporary Need Information",
    prefix: "B",
  },
  {
    name: "Employer Information",
    prefix: "C",
  },
  {
    name: "Point of Contact Information",
    prefix: "D",
  },
  {
    name: "Attorney or Agent Information (if applicable)",
    prefix: "E",
  },
  {
    name: "Job Opportunity and Minimum Requirements",
    prefix: "F.a",
  },
  {
    name: "Place of Employment and Wage Information",
    prefix: "F.b-c",
  },
  {
    name: "Other Material Terms and Conditions of the Job Offer",
    prefix: "F.d",
  },
  {
    name: "Recruitment Information",
    prefix: "F.e",
  },
  {
    name: "Other Supporting Documentation",
    prefix: "G/H",
  },
  {
    name: "Preparer",
    prefix: "I",
  },
  {
    name: "Appendix A - Multiple Worksites",
    prefix: "APPX <br/>A",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix C - Foreign Labor Recruiter Information",
    prefix: "APPX <br/>C",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix D - Job Contractor and Other Joint Employer Information",
    prefix: "APPX <br/>D",
    classes: "label-prefix-appx",
  },
  {
    name: "Application Documents",
    symbol: "upload",
  },
];

export { form_meta, form_nav };

export default [
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  page11,
  page12,
  page13,
  page14,
  page15,
  page16,
];
